import * as React from 'react';
import * as moment from 'moment';
import * as _ from 'lodash';
import * as qs from 'query-string';
import { Dispatch, connect } from 'react-redux';
import { ReportActionCreators, CenterActionCreators, IApplicationState, AppActionCreators, IFiveStarSurveyResponse, IBasicCenterListResponse } from '@nkr/store/index';
import { ICenterFiveStarSurveyType, ICenterFiveStarSurvey, ISortBy, ICenterBase, ICenterFiveStarWeightedAverageResults, IFiveStartCommentResults } from '@nkr/models/index';
import { Glyphicon, OverlayProps } from 'react-bootstrap';
import CenterFiveStarSurveyRow from './center-five-star-survey-row';
import { TableWrapper, OpportunitesWrapper } from './styles';
import NoData from './no-data';
import CenterFiveStarSurveyFilter from './center-five-star-survey-filter';
import { IAspectType } from '@nkr/models/index';
import { RouteComponentProps, withRouter } from 'react-router';
import AuditReportScoreTable from '@nkr/views/reports/audit-report-score-table';
import { PopoverWrapper } from '@nkr/views/admin/center/list/saturation-grid/overlays';

interface IOwnProps extends RouteComponentProps<{}> {
    centerId: number
}

interface IStateProps {
}

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getBasicCenterList: () => Promise<IBasicCenterListResponse>,
    getFiveStarSurvey: (centerId: number, startDate: string, endDate: string, surveyType: ICenterFiveStarSurveyType) => Promise<IFiveStarSurveyResponse>,
}

type TProps = IOwnProps & IStateProps & IDispatchProps;

interface IState {
    report: ICenterFiveStarSurvey[],
    weightedAverageResults: ICenterFiveStarWeightedAverageResults[],
    commentResults: IFiveStartCommentResults[],
    centerList: ICenterBase[],
    aspectType: IAspectType,
    sortBy: ISortBy,
    section: number,
    startDate: string,
    endDate: string,
    surveyType: ICenterFiveStarSurveyType,
}

const FiveStarSurveyScoreOverlay = ({ weightedAverageResults, ...props }: { weightedAverageResults: ICenterFiveStarWeightedAverageResults } & OverlayProps) => (
    <PopoverWrapper {...props}>
        <div style={{ display: 'flex', alignItems: 'center', fontSize: 12 }}>
            <div style={{ paddingRight: 10, textAlign: 'center' }}>
                <div style={{ borderBottom: '1px solid black' }}>Sum of Survey Ratings</div>
                <div>Total Survey Responses</div>
            </div>
            <div style={{ paddingLeft: 10, paddingRight: 10, textAlign: 'center', backgroundColor: '#ddd', paddingTop: 5, paddingBottom: 5 }}>
                <div style={{ borderBottom: '1px solid black' }}>{weightedAverageResults.centerScoreNumerator.toFixed(1)}</div>
                <div>{weightedAverageResults.centerScoreDenominator}</div>
            </div>
        </div>
    </PopoverWrapper>
);

class CenterFiveStarSurveyReport extends React.Component<TProps, IState> {
    readonly state: IState = {
        report: [],
        weightedAverageResults: [],
        commentResults: [],
        centerList: [],
        aspectType: {
            All: true,
            WorkUp: false,
            PreOp: false,
            SurgeryPlusThree: false,
            SurgeryPlusThirty: false
        },
        sortBy: { property: "centerAlias", direction: "asc" },
        section: 0,
        startDate: '',
        endDate: '',
        surveyType: {
            dash: false,
            dcn: true,
            nkr: true
        },
    }

    componentDidMount = () => {
        let parsed = qs.parse(location.search.length > 0 ? location.search : encodeURI(""), { arrayFormat: 'bracket' });
        let startDate = parsed.startDate != null ? parsed.startDate : moment().subtract(6, 'months').format('YYYY-MM-DD');
        let endDate = parsed.endDate != null ? parsed.endDate : moment().format('YYYY-MM-DD');
        let dash = parsed.stype != null ? parsed.stype.indexOf('dash') >= 0 : false;
        let dcn = parsed.stype != null ? parsed.stype.indexOf('dcn') >= 0 : true;
        let nkr = parsed.stype != null ? parsed.stype.indexOf('nkr') >= 0 : true;

        this.setState({
            startDate,
            endDate,
            surveyType: {
                dash,
                dcn,
                nkr
            }
        }, () => {
            this.getData();
        });
    }

    getData = () => {
        let { startDate, endDate, surveyType } = this.state;
        let centerId = this.props.centerId;

        this.props.showLoading("Getting survey data, one moment please...").then(async () => {
            let centerListResponse = await this.props.getBasicCenterList();

            if (centerListResponse.data.success) {
                this.setState({
                    centerList: centerListResponse.data.results
                });
            }

            this.filter(centerId, startDate, endDate, surveyType);
        });
    }

    filter = (centerId: number, startDate: string, endDate: string, surveyType: ICenterFiveStarSurveyType) => {
        this.props.getFiveStarSurvey(centerId, startDate, endDate, surveyType)
            .then(response => {
                let { reportResults: report, weightedAverageResults, commentResults } = response.data.results;

                this.setState({
                    report,
                    weightedAverageResults,
                    commentResults,
                }, () => {
                    this.setUrl(startDate, endDate, surveyType);
                });
            })
            .finally(() => {
                this.props.hideLoading();
            });
    }

    setUrl = (startDate: string, endDate: string, surveyType: ICenterFiveStarSurveyType) => {
        let paramList = [];

        paramList.push(encodeURI('startDate=' + startDate));
        paramList.push(encodeURI('endDate=' + endDate));

        if (surveyType.dash) {
            paramList.push(encodeURI('stype[]=dash'));
        }

        if (surveyType.dcn) {
            paramList.push(encodeURI('stype[]=dcn'));
        }

        if (surveyType.nkr) {
            paramList.push(encodeURI('stype[]=nkr'));
        }

        let params = paramList.join('&');

        let newUrl = '/center/' + this.props.centerId + '/reports/dash-board/center-five-star-surveys?' + params;

        window.history.pushState({}, '', newUrl);
    }

    handleFilterChange = (startDate: string, endDate: string, surveyType: ICenterFiveStarSurveyType) => {
        this.setState({
            startDate,
            endDate,
            surveyType
        });
    }

    handleFilter = () => {
        let { startDate, endDate, surveyType } = this.state;
        let centerId = this.props.centerId;

        this.props.showLoading("Getting survey data, one moment please...").then(() => {
            this.filter(centerId, startDate, endDate, surveyType);
        });
    }

    handleSectionChange = (section: number) => {
        this.setState({
            section,
            aspectType: {
                All: section == 0 ? true : false,
                WorkUp: section == 1 ? true : false,
                PreOp: section == 2 ? true : false,
                SurgeryPlusThree: section == 3 ? true : false,
                SurgeryPlusThirty: section == 4 ? true : false
            }
        });
    }

    renderHeaderSort = (property: string) => {
        if (this.state.sortBy.property == property) {
            return <Glyphicon glyph={this.state.sortBy.direction == 'asc' ? 'triangle-top' : 'triangle-bottom'} style={{ marginLeft: 5 }} />;
        } else {
            return null;
        }
    }

    render = () => {
        const results = _.first(this.state.report);
        const weightedAverageResults = _.first(this.state.weightedAverageResults);
        const aspect = this.state.aspectType;

        const opportunityList = this.state.commentResults.filter(x => (x.opportunities ?? '') != '');
        const commendationList = this.state.commentResults.filter(x => (x.commendations ?? '') != '');
        const scoreValue = weightedAverageResults ? weightedAverageResults.centerAverage.toFixed(1) : 'NV';

        return (
            <>
                <div style={{ marginBottom: 10, padding: '0px 5px 5px 5px' }}>
                    {weightedAverageResults && (
                        <AuditReportScoreTable
                            reportName='Donor Satisfaction Survey Score'
                            scoreValue={scoreValue}
                            overlay={FiveStarSurveyScoreOverlay({ weightedAverageResults })}
                        />
                    )}

                    <CenterFiveStarSurveyFilter
                        startDate={this.state.startDate}
                        endDate={this.state.endDate}
                        surveyType={this.state.surveyType}
                        centerList={this.state.centerList}
                        isAdmin={false}
                        section={this.state.section}
                        onFilterChange={this.handleFilterChange}
                        onSectionChange={this.handleSectionChange}
                        onFilter={this.handleFilter}
                    />

                    {results ?
                        <div style={{ width: '100%' }}>
                            <TableWrapper bordered condensed striped style={{ borderTop: 'none', borderRight: 'none' }}>
                                <thead>
                                    <tr>
                                        <th style={{ textAlign: "left" }} rowSpan={2} >Aspect</th>
                                        <th colSpan={5}>Quantity of Responses</th>
                                        <th colSpan={4}>Averages</th>
                                        <th colSpan={3}>Comparison</th>
                                    </tr>
                                    <tr>
                                        <th style={{ textAlign: "center" }}>1 Star</th>
                                        <th>2 Star</th>
                                        <th>3 Star</th>
                                        <th>4 Star</th>
                                        <th>5 Star</th>
                                        <th>{results.centerAlias}</th>
                                        <th>(n)</th>
                                        <th>Network</th>
                                        <th>(n)</th>
                                        <th>+/-</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {(aspect.All || aspect.WorkUp) && (
                                        <>
                                            <CenterFiveStarSurveyRow
                                                key={'survey-wt'}
                                                aspectName="Workup Treatment:"
                                                detail={results.workupTreatment}
                                            />
                                            <CenterFiveStarSurveyRow
                                                key={'survey-wc'}
                                                aspectName="Workup Convenience:"
                                                detail={results.workupConvenience}
                                            />
                                            <CenterFiveStarSurveyRow
                                                key={'survey-wf'}
                                                aspectName="Workup Facility:"
                                                detail={results.workupFacility}
                                            />
                                        </>)
                                    }

                                    {(aspect.All || aspect.PreOp) && (
                                        <>
                                            <CenterFiveStarSurveyRow
                                                key={'survey-pot'}
                                                aspectName="Pre-Op Treatment:"
                                                detail={results.preOpTreatment}
                                            />
                                            <CenterFiveStarSurveyRow
                                                key={'survey-poc'}
                                                aspectName="Pre-Op Convenience:"
                                                detail={results.preOpConvenience}
                                            />
                                            <CenterFiveStarSurveyRow
                                                key={'survey-pof'}
                                                aspectName="Pre-Op Facility:"
                                                detail={results.preOpFacility}
                                            />
                                        </>)
                                    }

                                    {(aspect.All || aspect.SurgeryPlusThree) && (
                                        <>
                                            <CenterFiveStarSurveyRow
                                                key={'survey-st'}
                                                aspectName="Surgery Treatment:"
                                                detail={results.surgeryTreatment}
                                            />
                                            <CenterFiveStarSurveyRow
                                                key={'survey-sc'}
                                                aspectName="Surgery Convenience:"
                                                detail={results.surgeryConvenience}
                                            />
                                            <CenterFiveStarSurveyRow
                                                key={'survey-sf'}
                                                aspectName="Surgery Facility:"
                                                detail={results.surgeryFacility}
                                            />
                                        </>)
                                    }

                                    {(aspect.All || aspect.SurgeryPlusThirty) && (
                                        <>
                                            <CenterFiveStarSurveyRow
                                                key={'survey-ds'}
                                                aspectName="Donor Surgeon:"
                                                detail={results.postSurgerySurgeon}
                                            />
                                            <CenterFiveStarSurveyRow
                                                key={'survey-ns'}
                                                aspectName="Nursing Staff:"
                                                detail={results.postSurgeryNursing}
                                            />
                                            <CenterFiveStarSurveyRow
                                                key={'survey-p,'}
                                                aspectName="Pain Management:"
                                                detail={results.postSurgeryPainManagement}
                                            />
                                            <CenterFiveStarSurveyRow
                                                key={'survey-tc'}
                                                aspectName="Treatment of Caretaker:"
                                                detail={results.postSurgeryCaretakerTreatment}
                                            />
                                        </>)
                                    }
                                </tbody>

                                <tfoot>
                                    <tr>
                                        <td style={{ textAlign: "left" }}>Overall Average</td>
                                        <td colSpan={5}></td>
                                        <td>{weightedAverageResults.centerAverage.toFixed(1)}</td>
                                        <td>{weightedAverageResults.centerTotal.toLocaleString("en-us")}</td>
                                        <td>{weightedAverageResults.overallAverage.toFixed(1)}</td>
                                        <td>{weightedAverageResults.overallTotal.toLocaleString("en-us")}</td>
                                        <td>{((parseFloat(weightedAverageResults.overallAverage.toFixed(1))) - (parseFloat(weightedAverageResults.centerAverage.toFixed(1)))).toFixed(1)}</td>
                                    </tr>
                                </tfoot>
                            </TableWrapper>

                            <div className="row">
                                <div className="col-xs-12">
                                    <div style={{ marginBottom: "20px;" }}>
                                        <h3>Improvement Ideas and Commendations</h3>
                                    </div>

                                    <OpportunitesWrapper bordered condensed striped style={{ borderTop: 'none', borderRight: 'none' }}>
                                        <tbody>
                                            <tr>
                                                <td>
                                                    <h4>{results.centerAlias}</h4>
                                                    <div style={{ marginLeft: "20px" }}>
                                                        <h5>Ideas for improvement opportunities</h5>
                                                        <ol>
                                                            {opportunityList.map(item =>
                                                                <li>{item.opportunities}</li>
                                                            )}
                                                        </ol>
                                                        <h5>Commendations on an exceptional job</h5>
                                                        <ol>
                                                            {commendationList.map(item =>
                                                                <li>{item.commendations}</li>
                                                            )}
                                                        </ol>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </OpportunitesWrapper>
                                </div>
                            </div>
                        </div>
                        :
                        <NoData message={'No records...'} />
                    }
                </div>
            </>
        );
    }
}

const mapStateToProps = (appState: IApplicationState, ownProps: IOwnProps): IStateProps => {
    return {
    }
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        getBasicCenterList: () => {
            return dispatch(CenterActionCreators.getBasicCenterList(false));
        },
        getFiveStarSurvey: (centerId, startDate, endDate, surveyType) => {
            return dispatch(ReportActionCreators.getFiveStarSurvey(centerId, startDate, endDate, surveyType));
        }
    };
}

export default withRouter(connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    mapDispatchToProps)(CenterFiveStarSurveyReport));